import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';

/**
 * Component that checks Auth0 session validity on navigation and page refresh
 * This detects SSO logout from other apps (Hub, OptiFleet) without impacting API performance
 */
const SessionCheck = () => {
  const location = useLocation();
  const { getAccessToken, isAuthenticated } = useAuth();

  // Check session on navigation
  useEffect(() => {
    if (!isAuthenticated) return;

    const checkSession = async () => {
      try {
        // Force refresh to check Auth0 session on server (detects SSO logout)
        await getAccessToken(true);
      } catch (error) {
        console.error('Session check failed on navigation:', error);
      }
    };

    checkSession();
  }, [location.pathname, isAuthenticated, getAccessToken]);

  // Check session on page load/refresh
  useEffect(() => {
    if (!isAuthenticated) return;

    const checkSessionOnLoad = async () => {
      try {
        await getAccessToken(true);
      } catch (error) {
        console.error('Session check on load failed:', error);
      }
    };

    checkSessionOnLoad();
  }, [isAuthenticated, getAccessToken]);

  return null; // This component doesn't render anything
};

export default SessionCheck;
